<template>
	<div id="services-container">
		<div v-if="isDetailSelected == false"><PSServicesOverview :services="services" /></div>
		<div v-if="isDetailSelected == true"><PSServiceDetail :services="services" :detail="currentServiceDetail" /></div>
	</div>
</template>

<script>
import PSServicesOverview from '@/components/PSServicesOverview.vue'
import PSServiceDetail from '@/components/PSServiceDetail.vue'

export default {
	components : {
		PSServicesOverview,
		PSServiceDetail
	},
	props : {
		services : Array,
		sid: Number,
	},
    data() {
        return {
			currentServiceId: -1
        }
	},
	watch: {
        sid: function(newVal) {
            this.currentServiceId = newVal;
        }
    },
	mounted : function(){
		this.currentServiceId = this.sid;
	},
	methods : {
		viewServiceDetail : function(serviceId) {
			this.$parent.setCurrentServiceId(serviceId);
			this.scrollWindowTo("#services-container");
		},
		scrollWindowTo : function(refName) {
            var element = document.querySelector(refName);
            var topOffset = element.offsetTop;
            window.scrollTo({top: topOffset, behavior: 'auto'});
		},
		setContactFormDefault : function(serviceId) {
            this.$parent.setCurrentServiceId(serviceId);
        }
	},
	computed : {
		isDetailSelected : function() {
			return this.currentServiceId >= 0;
		},
		currentServiceDetail : function() {
			return this.services.find(x => x.id == this.currentServiceId);
		}
	}
}
</script>

<style scoped>

</style>